import React from "react";

/*
    Edit Icon
    props:
        - title: string, override the default title 'Edit'
        - color: string, override the default color '#00549A' (bell blue)
*/

const EditIcon = (props) => (
    <svg className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Edit"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16L3.42631 15.0471L13.409 5.07161L10.892 2.61844L0.939571 12.5635L0 16Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9986 0.514314L11.6505 1.86078L14.1759 4.30605L15.4848 2.99834C16.1717 2.31221 16.1717 1.20037 15.4848 0.514314C14.7981 -0.171438 13.6845 -0.171438 12.9986 0.514314Z"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
        />
    </svg>
);

export default EditIcon;
